import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

export interface ModernizationPodDto {
  podId: number;
  name: string;
  isVisible: boolean;
}

@Injectable({
  providedIn: 'root',
})
export class PodsService {
  constructor(private http: HttpClient) {}

  getAll(): Observable<ModernizationPodDto[]> {
    return this.http.get<ModernizationPodDto[]>(`${environment.apiUrl}/admin/pods`);
  }

  create(dto: Omit<ModernizationPodDto, 'podId'>): Observable<ModernizationPodDto> {
    return this.http.post<ModernizationPodDto>(`${environment.apiUrl}/admin/pods`, dto);
  }

  update(podId: number, dto: Omit<ModernizationPodDto, 'podId'>): Observable<ModernizationPodDto> {
    return this.http.put<ModernizationPodDto>(`${environment.apiUrl}/admin/pods/${podId}`, {
      podId,
      ...dto,
    });
  }

  delete(podId: number): Observable<any> {
    return this.http.delete(`${environment.apiUrl}/admin/pods/${podId}`);
  }
}
